import { ArrowDownRight } from "lucide-react";
import { Link } from "react-router-dom";
import { siteContent } from "../content/loadContent";
import { PageCopy, PageIndex, PageMedia } from "../components/site/PagePrimitives";
import "./pages.css";

const ticker = ["BEGIN", "TRY", "LEARN", "RETURN", "KEEP GOING"];

export function HomePage() {
  const { profile } = siteContent;

  return (
    <article className="experience-page page-home" aria-labelledby="home-title">
      <PageMedia src="/assets/athlete/home-impact.webp" alt="" className="page-media--home" />
      <PageIndex number="01" label="HOME" />
      <PageCopy className="home-copy">
        <p className="page-kicker">WATER POLO · 2011 · SHANGHAI</p>
        <h1 id="home-title" className="athlete-name">
          <span>{profile.name}</span>
          <strong>{profile.nameEn.toUpperCase()}</strong>
        </h1>
        <p className="page-anthem">NOT FINISHED. JUST STARTED.</p>
        <Link className="next-route" to="/journey">
          <span>EXPLORE THE JOURNEY</span>
          <ArrowDownRight size={21} aria-hidden="true" />
        </Link>
      </PageCopy>
      <div className="motion-ticker" aria-hidden="true">
        <div className="motion-ticker__track">
          {[...ticker, ...ticker].map((item, index) => (
            <span key={`${item}-${index}`}>{item}</span>
          ))}
        </div>
      </div>
    </article>
  );
}
